import React, { FC, MouseEvent } from 'react';
import { capitalize, reject } from 'lodash';
import { UserProfileLinkTypeEnum } from '@src/graphql/generated';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { trackEvent } from '@src/metrics';
import { UserDetailsProps } from './props';
import './styles.scss';

const ABSOLUTE_LINK_TEST = /^(http[s]*|\/\/)/i;

export const UserDetails: FC<UserDetailsProps> = ({ userPosition, userNameLabel, location, links, userId }) => {
  const filteredLinks = reject(links, ({ type }) => type === UserProfileLinkTypeEnum.LINKEDIN);

  const onSignalRecordOnThirdPartyLinkClick = (event: MouseEvent, type: UserProfileLinkTypeEnum) => {
    event.stopPropagation();

    if (type === UserProfileLinkTypeEnum.LINKEDIN) {
      trackEvent({
        context: MetricContext.TALENT_AGENT_FEED,
        interaction: MetricAction.CLICK_RECOMMENDED_USER_LINKEDIN_ICON,
        payload: {
          'User Id': userId,
        },
      });
    }
  };

  return (
    <div className="ta-carousel-card-user-details">
      <h3 className="ta-carousel-card-user-details__user-position">{userPosition}</h3>

      <p className="ta-carousel-card-user-details__user-name">{userNameLabel}</p>

      <p className="ta-carousel-card-user-details__user-location">I'm from {location}</p>

      <div className="ta-carousel-card-user-details__links">
        {filteredLinks.map((link, index) => (
          <a
            href={ABSOLUTE_LINK_TEST.test(link.value) ? link.value : `https://${link.value}`}
            key={index}
            onClick={event => onSignalRecordOnThirdPartyLinkClick(event, link.type)}
            target="_blank"
            rel="noreferrer"
          >
            {capitalize(link.type === 'OTHER' ? 'My Portfolio' : link.type)}
          </a>
        ))}
      </div>
    </div>
  );
};
